export default {
  title: 'World Manufacturer Identifier',
  close: 'Schließen',
  cookiePolicy: {
    headline: 'Hinweis zur Verwendung von Cookies',
    text: 'Cookies erleichtern die Bereitstellung unserer Dienste. Mit der Nutzung unserer Dienste erklären Sie sich damit einverstanden, dass wir Cookies verwenden. Weitere Informationen zum Datenschutz erhalten Sie über den folgenden Link:',
    datenschutz: {
      text: 'Datenschutz',
      href: 'https://www.kba.de/DE/Service/Hinweise/Datenschutz/datenschutz_node.html'
    },
    button: 'OK'
  },
  kba: {
    breadcrumb: {
      start: 'Startseite'
    },
    logo: {
      title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)',
      href: 'https://www.kba.de/DE/Home/home_node.html'
    },
    header: {
      contact: {
        label: 'Kontakt',
        href: 'https://www.kba.de/DE/Service/Kontakt/kontakt_node.html',
        title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
      },
      press: {
        label: 'Presse',
        href: 'https://www.kba.de/DE/Presse/presse_node.html',
        title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
      },
      glossary: {
        label: 'Glossar',
        href: 'https://www.kba.de/DE/Service/Glossar1/glossar_node.html',
        title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
      },
      rss: {
        label: 'RSS',
        href: 'https://www.kba.de/DE/Service/RSSNewsfeed/rssnewsfeed_node.html',
        title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
      },
      logout: {
        label: 'Abmelden'
      },
      topics: 'Themen',
      statistic: 'Statistik',
      publications: 'Veröffentlichungen',
      kba: 'Das KBA'
    },
    footer: {
      topics: {
        title: 'Themen',
        drivingSutability: 'Fahreignungs Bewertungssystem',
        centralRegister: 'Zentrale Register',
        typeApproval: 'Typgenehmigung',
        marketSurveillance: 'Marktüberwachung'
      },
      statistics: {
        title: 'Statistik',
        products: 'Produkte der Statistik',
        vehicles: 'Fahrzeuge',
        drivers: 'Kraftfahrer',
        motorTransport: 'Kraftverkehr',
        researchDataCenter: 'Forschungsdatenzentrum',
        projects: 'Projekte',
        userInformation: 'Nutzerinformationen',
        methods: 'Methodische Erläuterungen',
        publicationsVehicleStatistics: 'Bekanntmachungen zur Fahrzeugstatistik',
        directories: 'Verzeichnisse',
        questionnaireRoadHaulageStatistics:
          'Fragebogen zur Güterkraftverkehrsstatistik',
        faqStatistic: 'Fragen & Antworten zur Statistik'
      },
      services: {
        title: 'Service',
        onlineSericeCitizen: 'Online-Service Bürger/-innen',
        onlineServiceRegisteredUsers: 'Online-Service registrierte Nutzer',
        openData: 'Open Data',
        formulars: 'Formulare'
      },
      publications: {
        title: 'Veröffentlichungen'
      },
      kba: {
        title: 'Das KBA',
        titleLong: 'Das Kraftfahrt-Bundesamt',
        president: 'Der Präsident',
        organization: 'Organisation',
        advisoryBoard: 'Beirat beim KBA',
        working: 'Arbeiten beim KBA',
        apprenticeship: 'Ausbildung beim KBA',
        internship: 'Praktikum beim KBA',
        history: 'Geschichte, Broschüren und Faltblätter',
        contact: 'Kontakt',
        directions: 'Anfahrt',
        businessHours: 'Öffnungszeiten'
      },
      middleFooter: {
        description:
          'ist eine Bundesoberbehörde im Geschäftsbereich des ',
        centralAuthorityNumber: 'Zentrale Behördennummer',
        infoNumber: 'Für alle Fragen zu Behörden in Deutschland',
        hours: 'Mo – Fr von 8:00 – 18:00 Uhr',
        bmv: {
          label: 'Bundesministeriums für Verkehr.',
          href: 'https://www.bmv.de/DE/Home/home.html',
          title: 'Externer Link zur Internetseite des Bundesministeriums für Verkehr (Öffnet neues Fenster)'
        }
      },
      lowerFooter: {
        accessibility: {
          label: 'Barrierefreiheit',
          href: 'https://www.kba.de/DE/Service/Hinweise/Barrierefreiheit/barrierefreiheit_node.html',
          title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
        },
        imprint: {
          label: 'Impressum',
          href: 'https://www.kba.de/DE/Service/Impressum/impressum_node.html',
          title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
        },
        privacy: {
          label: 'Datenschutz',
          href: 'https://www.kba.de/DE/Service/Hinweise/Datenschutz/datenschutz_node.html',
          title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
        },
        explanation: {
          label: 'Hilfe',
          href: 'https://www.kba.de/DE/Service/Hilfe/hilfe_node.html',
          title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
        },
        content: {
          label: 'Inhaltsverzeichnis',
          href: 'https://www.kba.de/DE/Service/Sitemap/sitemap_node.html',
          title: 'Externer Link zur Internetseite des Kraftfahrt-Bundesamtes (Öffnet neues Fenster)'
        }
      }
    }
  },
  dataIterator: {
    noResultsText: 'Keine Elemente gefunden',
    loadingText: 'Lade Elemente...'
  },
  dataTable: {
    itemsPerPageText: 'Zeilen pro Seite:',
    ariaLabel: {
      sortDescending: ': Absteigend sortiert. Aktivieren um Sortierung zu entfernen.',
      sortAscending: ': Aufsteigend sortiert. Aktivieren um absteigend zu sortieren.',
      sortNone: ': Nicht sortiert. Aktivieren um aufsteigend zu sortieren.'
    },
    sortBy: 'Sortiere nach'
  },
  dataFooter: {
    itemsPerPageText: 'Elemente pro Seite:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
    pageText: '{0}-{1} von {2}'
  },
  datePicker: {
    itemsSelected: '{0} ausgewählt'
  }
}
